import { Component, OnInit, Input, Output, EventEmitter, ViewChild, ElementRef, ChangeDetectorRef } from '@angular/core';
import { HtmlBase, PropertyData, MainblockModel, BlockItem, BlockFile, BObjectModel, FileModel, BObjectSummary, QueovalItem } from '../../../../models';
import { BaseAddOnComponent } from '../base-addon.component';
import { HttpService, CoreService, FilesManagerService } from '../../../../services';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastService } from '../../../../toast';
import { AccesPortailModel } from '../../../../models/acces-portail/acces-portail.model';


@Component({
  selector: 'q-admin-acces-portail',
  templateUrl: './admin-acces-portail.component.html',
  styleUrls: ['./admin-acces-portail.component.css', '../../dynamictag.component.css']
})
export class AdminAccesPortailComponent extends BaseAddOnComponent implements OnInit {
  @Input('model') model: BObjectModel;
  @Input('input') input: PropertyData;
  @Output() inputChange: EventEmitter<PropertyData> = new EventEmitter<PropertyData>(false);
  @Output() navig: EventEmitter<HtmlBase> = new EventEmitter<HtmlBase>(true);

  @ViewChild('closeModal') closeModal: ElementRef<HTMLButtonElement>;
  constructor(
    private http: HttpService,
    private modalService: NgbModal,
    private indParam: CoreService,
    private toast: ToastService,
    private cd: ChangeDetectorRef,
    public fileService: FilesManagerService,
  ) { super(); }


  ngOnInit(): void {
  }


  public OpenModalAdmin(content: any) {
    // Récupération de l'élément mail
    let objMail: HtmlBase | undefined;
    const PositionNeproPER = this.model.summary.filter((summary: BObjectSummary) => {
      return summary.ColumnName.toLowerCase() == 'neproper';
    });
    if (PositionNeproPER.length > 0 && PositionNeproPER[0].CountMainElementList > 0) {
      objMail = this.model.Body.SelectedGroupsList[PositionNeproPER[0].IndexGroupsList].DataList[PositionNeproPER[0].IndexDataList].MainElementList[0];
    }

    this.modalService.open(content, { size: 'xl', centered: true, windowClass: 'modal-admin-acces-portail' }).result.then((result) => {
      switch (result) {
        //  case 'SAVE': this.saveConfigSignature(); break;
        //  case 'CANCEL': this.closeConfigSignature(); break;
      }
    });
  }

  public CloseModalAdmin(result: AccesPortailModel | null, modalAdmin: any) {
    if (result && result.Success) {


      const PositionConx_PER = this.model.summary.filter((summary: BObjectSummary) => {
        return summary.ColumnName.toLowerCase() == 'conx_per';
      });
      if (PositionConx_PER.length > 0 && PositionConx_PER[0].CountMainElementList > 0) {
        this.model.Body.SelectedGroupsList[PositionConx_PER[0].IndexGroupsList].DataList[PositionConx_PER[0].IndexDataList].MainElementList[0].Value = result.Conx_PER.value;
      }

      const PositionPassePER = this.model.summary.filter((summary: BObjectSummary) => {
        return summary.ColumnName.toLowerCase() == 'passeper';
      });
      if (PositionPassePER.length > 0 && PositionPassePER[0].CountMainElementList > 0) {
        this.model.Body.SelectedGroupsList[PositionPassePER[0].IndexGroupsList].DataList[PositionPassePER[0].IndexDataList].MainElementList[0].Value = result.PassePER.value;
      }

      const PositionRole_PER = this.model.summary.filter((summary: BObjectSummary) => {
        return summary.ColumnName.toLowerCase() == 'role_per';
      });
      if (PositionRole_PER.length > 0 && PositionRole_PER[0].CountMainElementList > 0) {
        this.model.Body.SelectedGroupsList[PositionRole_PER[0].IndexGroupsList].DataList[PositionRole_PER[0].IndexDataList].MainElementList[0].Value = result.Role_PER.value;

        if (this.model.Body.SelectedGroupsList[PositionRole_PER[0].IndexGroupsList].DataList[PositionRole_PER[0].IndexDataList].MainElementList[0].SelectOptionsList) {
          this.model.Body.SelectedGroupsList[PositionRole_PER[0].IndexGroupsList].DataList[PositionRole_PER[0].IndexDataList].MainElementList[0].SelectOptionsList.forEach(
            (option: QueovalItem) => {
              if (option.Value == result.Role_PER.value) {
                option.Selected = true;
              } else {
                option.Selected = false;
              }
            })
        }
      }

      const PositionNeproPER = this.model.summary.filter((summary: BObjectSummary) => {
        return summary.ColumnName.toLowerCase() == 'neproper';
      });
      if (PositionNeproPER.length > 0 && PositionNeproPER[0].CountMainElementList > 0) {
        this.model.Body.SelectedGroupsList[PositionNeproPER[0].IndexGroupsList].DataList[PositionNeproPER[0].IndexDataList].MainElementList[0].Value = result.NeproPER.value;

        if (this.model.Body.SelectedGroupsList[PositionNeproPER[0].IndexGroupsList].DataList[PositionNeproPER[0].IndexDataList].MainElementList[0].SelectOptionsList) {
          this.model.Body.SelectedGroupsList[PositionNeproPER[0].IndexGroupsList].DataList[PositionNeproPER[0].IndexDataList].MainElementList[0].SelectOptionsList.forEach(
            (option: QueovalItem) => {
              if (option.Value == result.NeproPER.value) {
                option.Selected = true;
              } else {
                option.Selected = false;
              }
            })
        }
      }
    }
    modalAdmin.close();

  }

  public AffectValue(files: Array<BlockFile>, modalUploadDocument: any): void {
    if (files && files.length > 0) {
      this.input.MainElementList[0].Value = files[0].value;
      this.input.MainElementList[0].ToolTip = files[0].key;
      this.inputChange.emit(this.input);

    }
    modalUploadDocument.close();
  }
  public OnClear(): void {
    this.input.MainElementList[0].Value = '';
    this.input.MainElementList[0].ToolTip = '';
    this.inputChange.emit(this.input);
  }

  /**
 * Méthode de téléchargment des fichiers déjà générés
 * @param {FileGenerated} file fichier concerné
 */
  public DownLoadFile(htmlBase: HtmlBase): void {
    if (htmlBase.OnClick.toUpperCase() === 'OPENFILE' || htmlBase.OnClick.toUpperCase() === 'DOCXGENERE') {
      this.indParam.showSplash(true);
      const fileModel: FileModel = new FileModel();
      fileModel.DownloadMode = htmlBase.OnClick;
      fileModel.Ident = this.input.MainElementList[0].MoreValues.Ident;
      fileModel.Extension = htmlBase.MoreValues.Extension;
      fileModel.Name = this.input.MainElementList[0].MoreValues.Ident;
      this.fileService.downloadFile(fileModel, this.input.MainElementList[0].MoreValues.Name);
    } else {
      window.open(htmlBase.OnClick, '_blank')
    }
  }

  public OnButtonClick(element: HtmlBase, pContent: any): void {
    if (element.TypeModal)
      switch (element.TypeModal.toUpperCase()) {
        case 'MODAL':
          if (this.input) {
            this.OpenModalAdmin(pContent)
          }
          break;
        default:
          this.navig.emit(element);
          break;
      }
  }
}
